

/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import FilterCheckBoxCompSkill from '../UIElements/FilterCheckBoxCompSkill'

// Toggle container with flex layout for icon + label
const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0px;
  justify-content: space-between;
  height: 30px;
`

// Icon wrapper for the arrow toggle
const IconWrapper = styled.div`
  margin-left: auto;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CCCFD6;
  font-size: 10px;
`
const LabelWrapper = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #343E59;
  margin: 0;
  cursor:pointer;
`
const OuterDiv = styled.div`
margin-bottom: 15px;
padding: ${props => props.value ? '10px 16px' : '12px 16px'};
border: 1px solid #E6E7EA;
border-radius: 8px;
`
 const HorizontalDividerSkill = styled.div`
  width:auto;
  background:#D6DBF7;
  height: 1.5px;
  margin-top:10px;

`;


const Checkbox = ({ onChange, label, value, name, rules, list, options, onChangeCheck, valueParam, labelParam, ...rest }) => {
  // Handle toggle click
  const handleToggle = () => {
    // Keep the same event structure as the original checkbox for compatibility
    onChange({ target: { checked: !value } });
  };

  return (
    <>
    <OuterDiv>
      <ToggleContainer onClick={handleToggle}>
        <LabelWrapper>{label}</LabelWrapper>
        <IconWrapper>
          <span style={{ transform: value ? 'rotate(90deg)' : 'rotate(0deg)', display: 'inline-block', transition: 'transform 0.2s', fontSize: '8px' }}>▶</span>
        </IconWrapper>
      </ToggleContainer>
     
    </OuterDiv>
    {value && (
      <>
       
        <FilterCheckBoxCompSkill
          value={list}
          options={options}
          onChange={onChangeCheck}
          valueParam={valueParam}
          labelParam={labelParam}
        />
      </>
    )}
    </>
  )
}
export default Checkbox
